// extracted by mini-css-extract-plugin
module.exports = {"execbutton":"button_execbutton__1raCP","primary":"button_primary__3us13","cancel":"button_cancel__3XpAq","danger":"button_danger__lPf1s"};